import { Link, palette, Typography } from "@callcenter/design-system"
import { t } from "i18next"
import { useUnit } from "effector-react"
import { $whiteLabel } from "@callcenter/white-label"

import { BlockingOverlay } from "@callcenter-frontend/ui-components"

import { feedbackModel, kycModel, selfServiceModel, trialBalanceModel } from "../../models"
import { FeedbackModal } from "../feedback-modal"

export const TrialExpiredOverlay = () => {
  const { brandName } = useUnit($whiteLabel.$whiteLabelSettings)
  const isTrialExpired = useUnit(selfServiceModel.$isTrialExpired)
  const isUpgradeDisabled = useUnit(selfServiceModel.$isUpgradeDisabled)
  const isUnderReview = useUnit(selfServiceModel.$isUnderReview)
  const shouldShowKycResult = useUnit(kycModel.$shouldShowKycResult)
  const isTrialBalanceBlocked = useUnit(trialBalanceModel.$isTrialBalanceBlocked)

  const actions = useUnit({
    feedbackModalOpened: feedbackModel.feedbackModalOpened,
    upgrade: selfServiceModel.upgradeNowClicked
  })

  const handleFeedbackClick = (e: React.MouseEvent) => {
    e.preventDefault()
    actions.feedbackModalOpened()
  }

  if (!isTrialExpired || shouldShowKycResult || isUnderReview || isTrialBalanceBlocked) {
    return null
  }

  return (
    <>
      <BlockingOverlay
        title={t("component_commonKeys_trialExpired_title")}
        description={t("component_commonKeys_trialExpired_description", { x: brandName })}
        primaryButton={{
          text: t("component_commonKeys_trialExpired_upgradeButton"),
          tooltip: t("component_commonKeys_selfService_upgradeRequestSent_tooltipText"),
          isDisabled: isUpgradeDisabled,
          onClick: () => {
            actions.upgrade()
          }
        }}
        footer={
          <Typography.Body2 color={palette.gray7}>
            {t("component_commonKeys_trialExpired_feedbackPrompt")}{" "}
            <Link kind="button" onClick={handleFeedbackClick}>
              {t("component_commonKeys_trialExpired_feedbackLink")}
            </Link>
          </Typography.Body2>
        }
      />
      <FeedbackModal />
    </>
  )
}
